import React from "react";
import { Box } from "grid-styled";
import snakeCase from "lodash/snakeCase";
import { getReport } from "../api";
import ReportView from "./ReportView";
import CenteredLoader from "./CenteredLoader";

class Report extends React.Component {
  state = {
    loading: false,
    data: null
  };

  componentDidMount() {
    this.fetchReport();
  }

  fetchReport() {
    const { reportSlug } = this.props;
    this.setState({ loading: true });
    return getReport(snakeCase(reportSlug)).then(report => {
      this.setState({
        data: report,
        loading: false
      });
    });
  }

  render() {
    const { loading, data } = this.state;
    if (loading) return <CenteredLoader />;
    return (
      data && (
        <Box py={2} px={3}>
          <ReportView data={data} />
        </Box>
      )
    );
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/components/Report.js